<template>
    <section class="def-autocomplete">
        <div>
            <slot></slot>
        </div>
        <transition name="fade">
            <div class="def-autocomplete__items" v-if="value && Object.keys(result).length" ref="items">
                <PerfectScrollbar>
                    <span v-for="item in result" class="def-autocomplete__item"
                          :class="{ 'def-autocomplete__item_active': item[options.value] == selectedValue.value}"
                          @click="changeSelectedValue(item)"
                    >
                        {{ item[options.text] }}
                    </span>
                </PerfectScrollbar>
            </div>
        </transition>
    </section>
</template>

<script>
export default {
    name: 'def-autocomplete',
    props: {
        result: {
            type: [Array, Object]
        },
        options: {
            type: Object,
            default: () => ({
                text: 'NAME',
                value: 'ID',
            })
        },
        value: Boolean
    },
    data() {
        return {
            selectedValue: {
                text: '',
                value: '',
                ...this.options?.default,
            },
        }
    },
    methods: {
        changeSelectedValue(selected) {
            this.$emit('change', selected);
            this.$emit('input', false);
        },
        selectElement(e) {
            const {key} = e;
            const activeElement = this.$refs?.items?.querySelector('.def-autocomplete__item_active');
            if (activeElement) {
                switch (key) {
                    case 'ArrowDown': {
                        if (!activeElement) {
                            const firstElement = this.$refs?.items.querySelector('.def-autocomplete__item');
                            firstElement.classList.add('def-autocomplete__item_active');
                        } else if (activeElement.nextElementSibling) {
                            activeElement.classList.remove('def-autocomplete__item_active');
                            activeElement.nextElementSibling.classList.add('def-autocomplete__item_active');
                            activeElement.nextElementSibling.scrollIntoView();
                        }
                        break;
                    }
                    case 'ArrowUp': {
                        if (!activeElement) {
                            const tabIndexs = this.$refs?.items.querySelectorAll('span[tabindex]')
                            const lastElement = tabIndexs[tabIndexs.length - 1];
                            lastElement.classList.add('def-autocomplete__item_active');
                        } else if (activeElement.previousElementSibling) {
                            activeElement.classList.remove('def-autocomplete__item_active');
                            activeElement.previousElementSibling.classList.add('def-autocomplete__item_active');
                            activeElement.previousElementSibling.scrollIntoView();
                        }
                        break;
                    }
                    case 'Enter': {
                        let click = new Event('click');
                        activeElement.dispatchEvent(click);
                        this.$emit('input', false);
                    }
                }
            }
        },
        handlerDocumentClick({target}) {
            if (!target?.closest('.def-autocomplete')) {
                this.$emit('input', false);
            }
        }
    },
    watch: {
        value(prev) {
            if (prev) {
                document.addEventListener('keyup', this.selectElement);
                document.addEventListener('click', this.handlerDocumentClick);
            } else {
                document.removeEventListener('keyup', this.selectElement);
                document.removeEventListener('click', this.handlerDocumentClick);
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.def-autocomplete {
    position: relative;

    &__items {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: calc(100% - 1px);
        left: 0;
        right: 0;
        z-index: 2;
        background-color: #fff;
        max-height: 200px;
        border: 1px solid #DFDFDF;
        overflow-y: auto;
    }

    &__item {
        display: block;
        padding: 16px;
        transition: .2s linear background-color;

        &:hover {
            cursor: pointer;
            background-color: #DFDFDF;
        }

        &_active {
            background-color: #F7F8F9;
        }
    }
}

//
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}
</style>